var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValueChainIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3168_28029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 11.8667H15.3333V10.5333H19.3333C21.2 10.5333 22.6667 8.99999 22.6667 7.19999C22.6667 5.39999 21.1333 3.86666 19.3333 3.86666H4V2.53333H19.3333C21.9333 2.53333 24 4.59999 24 7.19999C24 9.79999 21.9333 11.8667 19.3333 11.8667Z",
    fill: "#3E7BFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8667 19.9333H4.66667C2.06667 19.9333 0 17.8666 0 15.2666C0 12.6666 2.06667 10.6 4.66667 10.6H8.66667V11.9333H4.66667C2.8 11.9333 1.33333 13.4666 1.33333 15.2666C1.33333 17.0666 2.86667 18.6 4.66667 18.6H14.8V19.9333H14.8667Z",
    fill: "#3E7BFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4 22.0667L12.4667 21.1334L14.3333 19.2667L12.4667 17.3334L13.4 16.4L16.2667 19.2667L13.4 22.0667Z",
    fill: "#3E7BFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5333 23.6001L20 22.9334C19.6 22.4001 17.4667 19.7334 17.4667 18.2667C17.4667 16.6001 18.8 15.2667 20.4667 15.2667C22.1333 15.2667 23.4667 16.6001 23.4667 18.2667C23.4667 19.7334 21.4 22.4001 20.9333 22.9334L20.5333 23.6001ZM20.5333 16.6001C19.6 16.6001 18.8667 17.3334 18.8667 18.2667C18.8667 18.8667 19.7333 20.3334 20.5333 21.4001C21.3333 20.2667 22.2 18.8667 22.2 18.2667C22.2 17.3334 21.4667 16.6001 20.5333 16.6001Z",
    fill: "#3E7BFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53333 5.73329C1.13333 5.73329 0 4.59996 0 3.19996C0 1.79996 1.13333 0.666626 2.53333 0.666626C3.93333 0.666626 5.06667 1.79996 5.06667 3.19996C5.06667 4.59996 3.93333 5.73329 2.53333 5.73329ZM2.53333 1.99996C1.86667 1.99996 1.33333 2.53329 1.33333 3.19996C1.33333 3.86663 1.86667 4.39996 2.53333 4.39996C3.2 4.39996 3.73333 3.86663 3.73333 3.19996C3.73333 2.53329 3.2 1.99996 2.53333 1.99996Z",
    fill: "#3E7BFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15.2001H8V7.26672H16V15.2001ZM9.33333 13.8667H14.6667V8.60006H9.33333V13.8667Z",
    fill: "#3E7BFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 7.93335H11.3333V9.80002H12.6666V7.93335Z",
    fill: "#3E7BFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2 17.8667H19.8667V18.8H21.2V17.8667Z",
    fill: "#3E7BFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3168_28029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueChainIconActive);
export default __webpack_public_path__ + "static/media/valueChainIconActive.b57a7abd629c06908cc69dab61a1b03e.svg";
export { ForwardRef as ReactComponent };